/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { CoachingCategoryDropdown } from '../../../../components/coachingCategoryDropdown/CoachingCategoryDropdown';
import { getRole } from '../../../../components/conversation/conversation-service';
import { CoreValueDropdown } from '../../../../components/coreValueDropdown/CoreValueDropdown';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';
import { RecipientDropdown } from '../../../../components/recipientDropdown/RecipientDropdown';
import {
    selectCurrentEmpid,
    selectCurrentIsAdmin,
    selectCurrentIsHC,
    selectCurrentRole,
    selectCurrentUserManagerLevel,
    selectIsPseudoSupervisor, // selectIsUseCoachingSkills
} from '../../../../pages/login/authSlice';
import { CoachingEntityTypes, CoachingTabs } from '../../../../utils/typeConstants';
import {
    useGetCoachingSummaryQuery,
    useGetEmployeeSearchQuery,
    useGetMyActivitySummaryQuery,
} from '../../coachingSlice';
import { SelectTeam } from '../../coachingSummary/SelectTeam';
import { useCreateConversationMutation } from '../conversationLogSlice';
import { ConversationLogProps } from '../types';
import './NewConversationLog.scss';
import Guidelines from '../guidelines/Guidelines';
import MultiFileUploadPreview from '../../../../components/fileUploads/MultiFileUploadPreview';
import { ROLES } from '../../../../constants';
// import { SkillBehaviorDropdown } from '../../../../components/skillBehaviorDropdown/SkillBehaviorDropdown';

const NewConversationLog = (props: ConversationLogProps) => {
    // const date = props.date || new Date();
    // const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const [CreateConversation] = useCreateConversationMutation();
    const [visible, setVisible] = useState(true);
    const [showVisible, setShowVisible] = useState(true);
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [coreValue, setCoreValue] = useState(0);
    const [conversationCategory, setConversationCategory] = useState(0);
    const [selectedTeam, setSelectedTeam] = useState<string>('');
    const [selectTeamList, setSelectTeamList] = useState<any>();
    const [showEmployeSearchInput, setShowEmployeSearchInput] = useState<boolean>(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [noResultMsg, setNoResultMsg] = useState<string>('');
    const [searchResults, setSearchResults] = useState<Array<any>>([]);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
    const [selectedRecipient, setSelectedRecipient] = useState<any>(null);
    const [recipientList, setRecipientList] = useState<any[]>([]);
    const userRole = getRole(useSelector(selectCurrentRole), useSelector(selectIsPseudoSupervisor));
    const [selectedDate, setSelectedFromDate] = useState<Date>(new Date());
    const [readGuidelines, setReadGuidelines] = useState(false);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const isAdmin = useSelector(selectCurrentIsAdmin);
    const isHC = useSelector(selectCurrentIsHC);
    const [discussionCoreValue, setDiscussionCoreValue] = useState<string>('');
    // const isUseCoachingSkills = useSelector(selectIsUseCoachingSkills);
    // const [skill, setSkill] = useState(0);
    // const [behavior, setBehavior] = useState(0);

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [fileErrorDialogVisible, setFileErrorDialogVisible] = useState(false);
    const [fileErrors, setFileErrors] = useState<string[]>([]);
    const now = new Date();
    const setViewState = (viewState: 'read' | 'edit' | 'new' | '') => {
        props.setViewState(viewState || 'read');
    };

    const { data: employeeSearchData } = useGetEmployeeSearchQuery(
        {
            searchedEmpNumber: debouncedSearchTerm,
            searcherEmpNo: loggedEmpNum,
            getAllEmps: (isAdmin || isHC || ROLES.Manager.includes(userManagerLevel)) && true,
        },
        {
            skip: debouncedSearchTerm.length <= 4,
        }
    );

    const { data: coachingSummaryGrid } = useGetCoachingSummaryQuery(
        {
            employeeNumber: props.authorId,
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            flag: false,
            loggedEmpRole: userManagerLevel,
            selectedTeam,
        },
        {
            skip:
                !props.authorId ||
                !selectedTeam ||
                (selectedTeam && selectedTeam === 'search') ||
                (selectedTeam && selectedTeam === 'myActivity'),
        }
    );
    const { data: myActivitySummaryGrid } = useGetMyActivitySummaryQuery(
        {
            loggedEmpNumber: props.authorId,
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            selectedTeam,
        },
        {
            skip:
                !props.authorId ||
                !selectedTeam ||
                (selectedTeam && selectedTeam === 'search') ||
                (selectedTeam && selectedTeam === 'myTeamActivity'),
        }
    );

    useEffect(() => {
        if (selectedTeam) {
            if (selectedTeam === 'myActivity' || selectedTeam === 'myTeamActivity') {
                setShowEmployeSearchInput(false);
                setSelectedRecipient(null);
            } else if (selectedTeam === 'search') {
                setShowEmployeSearchInput(true);
                setSelectedRecipient(null);
            }
        }
    }, [selectedTeam]);
    useEffect(() => {
        if (props.via === CoachingTabs.CoachingInsights) setSelectedFromDate(props.date || new Date());
    }, [props.date]);

    useEffect(() => {
        if (coachingSummaryGrid) {
            const fetchrecipientList: any[] = coachingSummaryGrid?.data?.map((item: any) => {
                return {
                    employeeNumber: item.employee_number,
                    employeeName: item.employee_name,
                };
            });
            setRecipientList(fetchrecipientList);
        }
    }, [coachingSummaryGrid]);

    useEffect(() => {
        if (myActivitySummaryGrid) {
            const fetchrecipientList: any[] = myActivitySummaryGrid?.data?.map((item: any) => {
                return {
                    employeeNumber: item.employee_number,
                    employeeName: item.employee_name,
                };
            });
            setRecipientList(fetchrecipientList);
        }
    }, [myActivitySummaryGrid]);
    const closeGuidelines = (message: boolean) => {
        setReadGuidelines(!message);
    };
    useEffect(() => {
        let timer: any = null;
        if (searchTerm.length >= 5) {
            timer = setTimeout(() => {
                setDebouncedSearchTerm(searchTerm);
            }, 1000);
        } else resetState();

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [searchTerm]);

    useEffect(() => {
        if (
            (props.via === CoachingTabs.Coaching ||
                props.via === CoachingTabs.History ||
                props.via === CoachingTabs.CoachingObservations) &&
            props.authorId === props.recieverId
        ) {
            setVisible(true);
            setShowVisible(false);
        } else {
            setShowVisible(true);
        }
        if (userRole === 'associate') {
            setVisible(true);
            setShowVisible(false);
        }
        if (props.via === CoachingTabs.CoachingObservations) {
            setConversationCategory(17);
        } else if( props.via === CoachingTabs.RecordingHistory) {
            setConversationCategory(1);
            setDiscussionCoreValue(props.discussionCoreValue || '');
        }
    }, []);
    useEffect(() => {
        if (props.via === CoachingTabs.Conversation && props.authorId === selectedRecipient?.employeeNumber) {
            setVisible(true);
            setShowVisible(false);
        } else {
            setShowVisible(true);
        }
    }, [selectedRecipient]);
    useEffect(() => {
        if (conversationCategory === 9) {
            setVisible(true);
        }
    }, [conversationCategory]);

    useEffect(() => {
        if (!employeeSearchData && selectedRecipient === null) setNoResultMsg('No results found');
        else setNoResultMsg('');

        setSearchResults(employeeSearchData?.data?.length > 0 ? employeeSearchData.data : []);

        if (debouncedSearchTerm.length === 0) resetState();
    }, [debouncedSearchTerm, employeeSearchData]);

    useEffect(() => {
        if ((props.coachingEntityTypeId === CoachingEntityTypes.CoachingInsights) || (props.coachingEntityTypeId === CoachingEntityTypes.Recordings)) {
            setDescription(props.discussionDesc || '');
            setSubject(props.discussionSubject || '');
        }
    }, [props.coachingEntityTypeId]);
    const resetState = () => {
        setSearchResults([]);
        setNoResultMsg('');
    };

    const validate = () => {
        const errors: string[] = [];

        if (props.via === CoachingTabs.Conversation && selectedRecipient === null) {
            errors.push('Recipient is required \n');
        }
        if (subject.trim().length === 0) {
            errors.push('Subject is required \n');
        }
        if (subject.trim().length > 100) {
            errors.push('Subject must be less than 100 characters \n');
        }
        if (!coreValue || coreValue === 0) {
            errors.push('TTEC  Corevalue is required \n');
        }

        // if (isUseCoachingSkills === true) {
        //     if (!skill || skill === 0) {
        //         errors.push('Skill is required \n');
        //     }

        //     if (!behavior || behavior === 0) {
        //         errors.push('Behavior is required \n');
        //     }
        // }
        if (description.trim().length < 10) {
            errors.push('Description is required and must be at least 10 characters \n');
        }
        if (description.trim().length > 4000) {
            errors.push('Description must be less than 4000 characters \n');
        }
        if (conversationCategory === 0) {
            errors.push('Discussion category is required \n');
        }

        const allowedExtensions = ['.pdf', '.png', '.docx', '.doc'];
        selectedFiles.forEach((f) => {
            const ext = `.${f.name.split('.').pop()?.toLowerCase()}`;
            if (!allowedExtensions.includes(ext)) {
                errors.push(`"${f.name}" — invalid file type. Only pdf, png, docx, doc allowed.`);
            }
        });

        if (errors.length > 0) {
            errors.forEach((error) => toast.error(error));
            return false;
        }
        return true;
    };

    const handleCancel = () => {
        setViewState('');
        props.setDisplayModal(false);
        setSubject('');
        setDescription('');
        setCoreValue(0);
        // setBehavior(0);
        // setSkill(0);
        setConversationCategory(0);
        setSelectedTeam('');
        setSelectedRecipient(null);
        setSelectTeamList([]);
        setRecipientList([]);
        setShowEmployeSearchInput(false);
        setSearchTerm('');
        setDebouncedSearchTerm('');
        setSearchResults([]);
        setSelectedFiles([]);
    };

    const handleSave = () => {
        if (!validate()) return;
        const currDate = selectedDate || new Date();

        const formData = new FormData();

        formData.append(
            'empNo',
            props.via === CoachingTabs.Conversation ? selectedRecipient?.employeeNumber : props.recieverId
        );
        formData.append('authorEmpNo', props.authorId);
        formData.append('coachingConversationCategoryId', String(conversationCategory));
        formData.append(
            'conversationDate',
            `${currDate.getFullYear()}-${currDate.getMonth() + 1}-${currDate.getDate()}`
        );
        formData.append('subject', subject);
        formData.append('conversationDescription', description);
        // formData.append('coreValueId', isUseCoachingSkills === false ? String(coreValue) : '0');
        formData.append('coreValueId', String(coreValue));
        formData.append('visibleToRecipient', String(visible));
        formData.append('coachingEntityTypeId', String(props.coachingEntityTypeId));
        formData.append('coachingEntityId', props.coachingEntityId ? String(props.coachingEntityId) : '0');
        // formData.append('coachingSkillId', isUseCoachingSkills === true ? String(skill) : '0');
        // formData.append('coachingBehaviorId', isUseCoachingSkills === true ? String(behavior) : '0');
       
        if(selectedFiles && selectedFiles.length > 0){
            selectedFiles.forEach((file: any) => {
                formData.append('formFile', file);
            });
        }

        CreateConversation(formData)
            .unwrap()
            .then((res: any) => {
                if (res?.data) {
                    const obj: any = {
                        empNo: selectedRecipient,
                        selectedMonth: `${currDate.getMonth() + 1}`,
                        selectedYear: `${currDate.getFullYear()}`,
                    };
                    if (props.getData) {
                        props.getData(obj);
                    }

                    toast.success('Discussion log saved successfully');
                    if (
                        props.via === CoachingTabs.CoachingInsights ||
                        props.via === CoachingTabs.CorrectiveActions ||
                        props.via === CoachingEntityTypes.CoachingMetricRecognition
                    )
                        props.setDisplayModal(false);
                    setViewState('read');
                    // setSubject('');
                    // setDescription('');
                    // setCoreValue(0);
                    // setConversationCategory(0);
                    // setSelectedTeam('');
                    // setSelectedRecipient(null);
                    // setSelectTeamList([]);
                    // setRecipientList([]);
                    // setShowEmployeSearchInput(false);
                    // setSearchTerm('');
                    // setDebouncedSearchTerm('');
                    // setSearchResults([]);
                } else toast.error('Error saving Discussion log');
            })
            .catch((error: any) => {
                toast.error(error);
            });
    };

    const handleDescriptionChange = (value: string) => {
        setDescription(value);
    };
    const renderHeader = () => {
        return (
            <div>
                <h3>Discussion Log</h3>
            </div>
        );
    };

    const handleSeletedOption = (option: any) => {
        const selectedEmployee = {
            employeeNumber: option.employee_number,
            employeeName: option.employee_name,
        };
        setSelectedRecipient(selectedEmployee);
        setShowEmployeSearchInput(false);
        setSearchTerm('');
        setDebouncedSearchTerm('');
        setSearchResults([]);
    };
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter' && searchResults.length > 0) handleSeletedOption(searchResults[0]);
    };

    const handleRecipientChange = (e: any) => {
        const selectedRecipient = recipientList.filter((item: any) => item.employeeNumber === e.value);
        setSelectedRecipient(selectedRecipient?.length > 0 ? selectedRecipient[0] : null);
    };

    return (
        <Dialog
            header={renderHeader()}
            visible={props.displayModal}
            onHide={() => {
                props.setDisplayModal(false);
                props.setViewState('read');
                setSelectedTeam('');
                setSelectedRecipient(null);
            }}
            className="card shadow bg-body rounded mt-4 border-0"
            style={{
                width: '66vw',
                height: '90vh',
            }}
            position="top-right"
            modal
            draggable={false}
            resizable={false}
        >
            {showVisible === true && (
                <>
                    <div className="d-flex justify-content-between">
                        <h5 className="mb-2">New Discussion</h5>
                        <div>
                            <h6>Visible to Recipient</h6>
                            <div className="d-flex justify-content-start switchbtn gap mt-2">
                                <span className="lightText">Off</span>
                                <InputSwitch
                                    checked={visible}
                                    onChange={(e) => setVisible(e.value)}
                                    disabled={
                                        ((props.via === CoachingTabs.Coaching ||
                                            props.via === CoachingTabs.History ||
                                            props.via === CoachingTabs.CoachingObservations) &&
                                            props.authorId === props.recieverId) ||
                                        (props.via === CoachingTabs.Conversation &&
                                            props.authorId === selectedRecipient?.employeeNumber)
                                    }
                                />
                                <span className="lightText">On</span>
                            </div>
                        </div>
                    </div>
                    {props.receiverName && <p>Assigned To: {props.receiverName} </p>}
                </>
            )}
            {props.via === CoachingTabs.Conversation && (
                <div className="row mt-2">
                    <div className="col-md-4">
                        <SelectTeam
                            selectTeamList={selectTeamList}
                            selectedTeam={selectedTeam}
                            userManagerLevel={userManagerLevel}
                            setSelectedTeam={setSelectedTeam}
                            setVisible={setShowEmployeSearchInput}
                            setSelectTeamList={setSelectTeamList}
                        />
                    </div>
                    {(selectedTeam === 'myActivity' || selectedTeam === 'myTeamActivity') && (
                        <div className="col-md-4" data-testid="abc">
                            <RecipientDropdown
                                recipientList={recipientList}
                                selectedRecipient={selectedRecipient}
                                handleRecipientChange={handleRecipientChange}
                            />
                        </div>
                    )}
                    {showEmployeSearchInput && (
                        <div className="col-md-4" style={{ marginTop: '30px', position: 'relative' }}>
                            <div className="p-input-icon-left" style={{ width: '98%' }}>
                                <i className="pi pi-search" />
                                <InputText
                                    keyfilter="pnum"
                                    maxLength={10}
                                    placeholder="Search"
                                    style={{ width: '100%' }}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            {searchResults.length > 0 ? (
                                <ul
                                    role="menu"
                                    className="suggest-container"
                                    style={{
                                        position: 'absolute',
                                        background: 'white',
                                        width: '91%',
                                        zIndex: '100',
                                    }}
                                >
                                    {searchResults.map((option: any) => (
                                        <li
                                            className="suggest-item"
                                            key={option.employee_number}
                                            role="menuitem"
                                            onClick={() => {
                                                handleSeletedOption(option);
                                                setVisible(false);
                                            }}
                                            onKeyDown={handleKeyDown}
                                        >
                                            {`${option.employee_name}-(${option.location}),${option.job_title}`}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p style={{ marginTop: '10px' }}>{noResultMsg}</p>
                            )}
                        </div>
                    )}
                    {selectedRecipient && !showEmployeSearchInput && selectedTeam === 'search' && (
                        <>
                            <div className="col-md-4" style={{ marginTop: '30px', position: 'relative' }}>
                                <InputText
                                    disabled
                                    placeholder="Recipient"
                                    className="w-100 borderRadius8"
                                    value={selectedRecipient.employeeName}
                                />
                            </div>
                            <div className="col-md-4" style={{ marginTop: '15px', position: 'relative' }}>
                                <Button
                                    label="Reset"
                                    style={{ fontWeight: 400, marginTop: '12px' }}
                                    className="btn-secondary mb-2"
                                    onClick={() => {
                                        setSelectedRecipient(null);
                                        setShowEmployeSearchInput(true);
                                    }}
                                />
                            </div>
                        </>
                    )}
                </div>
            )}
            <div className="logConversation-coaching mt-2 mb-2">
                {/* <div className="d-flex justify-content-start mb-3 ps-2 pe-2 pb-2">
                    <div className="col-4">
                        <div>Date</div>
                        <Calendar
                            id="fromDate"
                            value={selectedDate}
                            onChange={(e: any) => setSelectedFromDate(e.value)}
                            showIcon
                            dateFormat="dd-M-yy"
                        />
                    </div>
                </div> */}
                <div className="d-flex justify-content-start mb-3 ps-2 pe-2 pb-2">
                    <div className="row w-100">
                        <div className="col-md-4">
                            <h6>Date</h6>
                            <Calendar
                                id="fromDate"
                                value={selectedDate}
                                onChange={(e: any) => setSelectedFromDate(e.value)}
                                showIcon
                                dateFormat="dd-M-yy"
                                className="custom-calendar"
                            />
                        </div>
                        <div className="col-md-4">
                            <h6>Subject</h6>
                            <div>
                                <InputText
                                    data-testid="subject-input"
                                    placeholder="Subject"
                                    className="w-100 borderRadius8"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <CoachingCategoryDropdown
                                data-testid="category-dropdown"
                                fullWidth
                                category={conversationCategory}
                                setCategory={setConversationCategory}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-start mb-3 ps-2 pe-2 pb-2">
                    <div className="row w-100">
                        {/* {isUseCoachingSkills === true ? (
                            <div className="col-md-12 me-2">
                                <SkillBehaviorDropdown
                                    fullWidth
                                    skill={skill}
                                    setSkill={setSkill}
                                    behavior={behavior}
                                    setBehavior={setBehavior}
                                />
                            </div>
                        ) : ( */}
                        <div className="col-4 ">
                            <CoreValueDropdown
                                data-testid="core-value"
                                fullWidth
                                coreValue={coreValue}
                                setCoreValue={setCoreValue}
                                coreValueName={discussionCoreValue}
                            />
                        </div>
                        {/* )} */}
                    </div>
                </div>
                <div>
                    <DescriptionBox
                        data-testid="description-box"
                        createdByLabel="Author"
                        createdByValue={props.authorName}
                        title={'Description'}
                        limit={4000}
                        onChange={handleDescriptionChange}
                        value={description}
                    />
                </div>

                <div>
                    <Dialog
                        header={
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#b91c1c' }}>
                                <i className="pi pi-exclamation-circle" />
                                File Upload Error
                            </span>
                        }
                        visible={fileErrorDialogVisible}
                        style={{ width: '420px' }}
                        onHide={() => setFileErrorDialogVisible(false)}
                        footer={
                            <Button
                                label="OK"
                                className="p-button-danger"
                                onClick={() => setFileErrorDialogVisible(false)}
                                type="button"
                            />
                        }
                    >
                        <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
                            {fileErrors.map((err, i) => (
                                <li key={i}>{err}</li>
                            ))}
                        </ul>
                    </Dialog>
                    <MultiFileUploadPreview
                        onFilesSelected={setSelectedFiles}
                        onValidationError={(errors) => {
                            setFileErrors(errors);
                            setFileErrorDialogVisible(true);
                        }}
                    />
                </div>
                <div className="d-flex justify-content-end mt-2">
                    <div className="mt-2 mb-2">
                        <Button
                            label="Cancel"
                            onClick={handleCancel}
                            className="btn-secondary me-2"
                        />
                        <Button label="Save" onClick={handleSave} className="btn-primary me-2" />
                    </div>
                </div>
                <div className="d-flex justify-content-end mt-2 conversationQuote">
                    <p>
                        What gets <span>Rewarded</span> gets <span>Repeated</span>-Steven Covey
                    </p>
                </div>
                <Button
                    data-testid="guidelinesButton"
                    label="Guidelines"
                    icon="ConversationGuidelinesIcon"
                    onClick={() => setReadGuidelines(true)}
                    className="btn-primary"
                />
                {readGuidelines && (
                    <Guidelines location="NewConversationLog" closeGuidelines={closeGuidelines} />
                )}
            </div>
        </Dialog>
    );
};
export default NewConversationLog;
